import { render, staticRenderFns } from "./customer-account-manage.vue?vue&type=template&id=25999c85&scoped=true&"
import script from "./customer-account-manage.vue?vue&type=script&lang=js&"
export * from "./customer-account-manage.vue?vue&type=script&lang=js&"
import style0 from "./customer-account-manage.vue?vue&type=style&index=0&id=25999c85&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25999c85",
  null
  
)

export default component.exports